import common from '@/validator/CommonRules'

/**
 * 時限式レコメンド バリデーションルール
 */
export default {
  shops: 'required',
  elapsedAt: 'required_if:timing,0,1|between:1,60',
  image: {
    create: 'required|' + common.imageRule,
    edit: common.imageRule,
  },
  recommend: 'required',
  startAt: common.requiredDateRule + '|before:endAt',
  endAt: common.requiredDateRule + '|after:startAt',
}
